import React from "react";
import DataGrid, { Column, FilterRow } from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import ODataStore from "devextreme/data/odata/store";
import Button from "devextreme-react/button";
import { StoreErrorHandler } from "api/ApiClientBase";
import { dpaInstanceService } from "api/DPAInstanceService";
import { getToken } from "api/ApiClientBase";

const source = new DataSource({
    store: new ODataStore({
        version: 4,
        url: "odata/v4/DPAInstance",
        key: "Id",
        // TODO: refactor errorHandler and beforeSend
        errorHandler: StoreErrorHandler,
        beforeSend: (request) => {
            request.headers["Authorization"] = `Bearer ${getToken()}`;
        },
    }),
});

export function Requests() {
    const dataGridRef = React.useRef<DataGrid>(null);
    const [someSelected, setSomeSelected] = React.useState(false);
    const [busy, setBusy] = React.useState(false);

    const handleSelectedRowKeysChanged = (e: any) => {
        setSomeSelected(e?.length > 0);
    };

    const handleConfirm = async () => {
        const keys = dataGridRef.current?.instance.getSelectedRowKeys();
        const pomises = keys?.map((x) => dpaInstanceService.Confirm(x)) ?? [];
        setBusy(true);
        await Promise.all(pomises);
        handleRefresh();
        setBusy(false);
    };

    const handleRefresh = () => {
        dataGridRef.current?.instance.refresh();
    };

    return (
        <>
            <Button
                text="Confirm"
                type="success"
                onClick={handleConfirm}
                disabled={!someSelected || busy}
                icon="todo"
            />
            <Button icon="refresh" type="normal" onClick={handleRefresh} />
            <div></div>
            <DataGrid
                ref={dataGridRef}
                dataSource={source}
                hoverStateEnabled
                selection={{ mode: "multiple", showCheckBoxesMode: "always" }}
                onSelectedRowKeysChange={handleSelectedRowKeysChanged}
            >
                <FilterRow visible={true} />
                <Column dataField="Id" />
                <Column dataField="Name" />
                <Column dataField="InstanceId" />
                <Column dataField="IpAddress" />
                <Column dataField="Confirmed" />
                <Column dataField="RequestDate" dataType="datetime" />
                <Column dataField="ConfirmDate" dataType="datetime" />
                <Column dataField="ConfirmedBy" />
            </DataGrid>
        </>
    );
}
